// import React, { useState } from "react";
// import { Table } from "antd";

// class ListTable extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       clientHeight: 0,
//     };
//     // console.log(window.innerHeight )
//   }

//   componentDidMount() {
//     this.setState({ clientHeight: window.innerHeight });

//     window.addEventListener("resize", () => {
//       // console.log(window.innerHeight);
//       this.setState({
//         clientHeight: window.innerHeight,
//       });
//     });
//   }

//   render() {
//     return (
//       <div
//         className="dataTbl-wrapper"
//         style={{ height: "80vh", padding: "10px" }}
//       >
//         <Table
//           className="list-tbl-height"
//           {...this.props}
//           size="small"
//           scroll={{
//             y: this.state.clientHeight - 240,
//             x: this.props.scroll?.x ? this.props.scroll?.x : 1200,
//           }}
//           pagination={
//             this.props.pagination === false
//               ? false
//               : {
//                   current: this.props.currentPage,
//                   pageSize: this.props.pageSize,
//                   total: this.props.total,
//                 }
//           }
//         />
//       </div>
//     );
//   }
// }

// export default ListTable;

import React from "react";
import { Table } from "antd";
import { Resizable } from "react-resizable";

class ResizableTitle extends React.Component {
  render() {
    const { onResize, width, ...restProps } = this.props;

    if (!width) {
      return <th {...restProps} />;
    }
    return (
      <Resizable
        width={width}
        height={0}
        handle={
          <span
            className="react-resizable-handle"
            onClick={(e) => e.stopPropagation()}
          />
        }
        onResize={onResize}
        draggableOpts={{ enableUserSelectHack: false }}
      >
        <th {...restProps} />
      </Resizable>
    );
  }
}

class ListTable extends React.Component {
  constructor(props) {
    super(props);

    console.log("in listtable");
    this.state = {
      clientHeight: window.innerHeight,
      columns: this.props?.columns
        ? this.props?.columns.map((col, index) => ({
            ...col,
            onHeaderCell: (column) => ({
              width: column.width,
              onResize: this.handleResize(index),
            }),
          }))
        : "",
    };
  }

  componentDidMount() {
    // console.log(this.state.columns)
    this.updateClientHeight();
    window.addEventListener("resize", this.updateClientHeight);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateClientHeight);
  }

  updateClientHeight = () => {
    this.setState({ clientHeight: window.innerHeight });
  };

  componentDidUpdate(prevProps) {
    // Update columns when props change
    if (prevProps.columns !== this.props.columns) {
      this.setState({
        columns: this.props.columns.map((col, index) => ({
          ...col,
          onHeaderCell: (column) => ({
            width: column.width,
            onResize: this.handleResize(index),
          }),
        })),
      });
    }
  }

  handleResize =
    (index) =>
    (_, { size }) => {
      this.setState((prevState) => {
        const newColumns = [...prevState.columns];
        newColumns[index] = { ...newColumns[index], width: size.width };

        return { columns: newColumns };
      });
    };

  render() {
    return (
      <div
        className="dataTbl-wrapper"
        style={{ height: "100%", padding: "10px" }}
      >
        <Table
          className={`list-tbl-height ${this.props.moreClass}`}
          {...this.props}
          size="small"
          scroll={{
            y: this.state.clientHeight - 240,
            x: this.props.scroll?.x ? this.props.scroll?.x : 1200,
          }}
          // scroll={
          //   this.props.dataSource && this.props.dataSource.length > 0
          //     ? {
          //         y: this.state.clientHeight - 240,
          //         x: this.props.scroll?.x ? this.props.scroll?.x : 1200,
          //       }
          //     : { x: this.props.scroll?.x ? this.props.scroll?.x : 1200 }
          // }
          components={{
            header: {
              cell: ResizableTitle,
            },
          }}
          columns={this.state.columns}
          // pagination={true}
          pagination={
            this.props.pagination === false
              ? false
              : {
                  current: this.props.currentPage,
                  pageSize: this.props.pageSize,
                  total: this.props.total,
                  showSizeChanger: this.props.showSizeChanger,
                }
          }
        />
      </div>
    );
  }
}

export default ListTable;
